export const threeColumnLayout = { xs: { span: 24 }, sm: { span: 24 }, md: { span: 8 }, lg: { span: 8 }, xl: { span: 8 }, xxl: { span: 8 } };
export const twoColumnLaytout = { xs: { span: 24 }, sm: { span: 24 }, md: { span: 16 }, lg: { span: 16}, xl: { span: 16}, xxl: { span: 16 } };
export const rowGutter = { xs: 8, sm: 16, md: 24, lg: 32 };


// const twoColumnLayout = {
  //   xs: { span: 24 },
  //   sm: { span: 24 },
  //   md: { span: 16 },
  //   lg: { span: 10 },
  //   xl: { span: 10 },
  //   xxl: { span: 16 },
  // };